<template>
  <section
    class="split"
    :class="[sectionBgClass,sectionAlignmentClass]">
    <div class="split__media" :class="[mediaAlignmentClass]">
      <component :is="mediaComponent" class="split__media__link" :to="{path: route}">
        <div
          class="split__media__logo"
          :class="[logoPositionClass]">
          <SvgLogo color="#ffffff"/>
        </div>
        <div class="split__media__img">
          <ModuleImage :imageUrl="image" :placeholderUrl="placeholderImage" :lazyLoad="true"/>
        </div>
      </component>
    </div>
    <div class="split__content">
      <div class="split__content__inner-wrapper" :class="[innerAlignmentClass]">
        <div class="split__text-content" :class="[textAlignmentClass]">
          <div v-if="label" class="split__label">
            <h4 class="split__label__heading">{{label}}</h4>
          </div>
          <div class="split__text-content__header">
            <BaseHeading :size="2" :color="fontColor">{{heading}}</BaseHeading>
          </div>
          <div class="split__text-content__text">
            <BaseText :color="fontColor"><p v-html="text"></p></BaseText>
          </div>
          <div class="split__links" v-if="route">
            <div class="split__links__link">
              <BaseButton buttonText="Läs mer" :color="buttonColor" :route="{path: route}"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SplitSection',
  props: {
    heading: String,
    label: String,
    alignment: String,
    route: String,
    text: String,
    image: String,
    theme: String,
    placeholderImage: String
  },
  computed: {
    mediaComponent () {
      return this.route ? 'router-link' : 'div'
    },
    fontColor: function () {
      return this.theme === 'dark' ? 'white' : 'black'
    },
    buttonColor: function () {
      return this.theme === 'dark' ? 'white' : 'black'
    },
    sectionBgClass: function () {
      return this.theme === 'dark' ? 'split--bg-dark' : null
    },
    sectionAlignmentClass: function () {
      return this.alignment === 'right' ? 'split--align-right' : null
    },
    logoPositionClass: function () {
      return this.alignment === 'right' ? 'split__media__logo--left' : null
    },
    mediaAlignmentClass: function () {
      return this.alignment === 'right' ? 'split__media--align-left' : null
    },
    innerAlignmentClass: function () {
      return this.alignment === 'right' ? 'split__content__inner-wrapper--align-right' : null
    },
    textAlignmentClass: function () {
      return this.alignment === 'right' ? 'split__text-content--align-right' : null
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "./section-split";
</style>



// WEBPACK FOOTER //
// src/components/SectionSplit/SectionSplit.vue